import { useEffect, useState } from "react";
import Icon from "@mdi/react";
import axios from "../config/api";

// Components
import Header from "../components/Header";
import CountryCard from "../components/CountryCard";
import PlaceholderCard from "../components/PlaceholderCard";
import {
  Columns,
  Container,
  Form,
  Icon as BIcon,
  Level,
  Heading,
} from "react-bulma-components";
import InfiniteScroll from "react-infinite-scroll-component";

import { mdiFilter } from "@mdi/js";

// shorten Form components
const { Input, Control } = Form;

// Home page of my site
const Home = () => {
  const [countries, setCountries] = useState([]); // use in axios retrieving data
  const [random, setRandom] = useState([]); // use in header to randomised countries
  const [pagination, setPagination] = useState([]); //
  const [hasMore, setHasMore] = useState(true); // both use in InfiniteScroll Component
  const [filter, setFilter] = useState(""); // use in filtering country name

  // Fetching for data and assign to countries and pagination states
  useEffect(() => {
    axios
      .get(
        "/all?fields=name,flags,coatOfArms,subregion,capital,population,latlng"
      )
      .then((response) => {
        let data = response.data;
        setCountries(response.data);

        let rng = Math.floor(Math.random() * data.length); // randomised numbers from the length of countries
        setRandom(data[rng]); // get country from rng

        // Initial data to pre-load Infinite Scroll Component
        for (let i = 1; i <= 15; i++) {
          setPagination((prevPag) => [...prevPag, data[i]]);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    console.log(countries);
  }, []);

  // onClick function for random button
  const handleRandomClick = () => {
    let rng = Math.floor(Math.random() * countries.length);
    setRandom(countries[rng]);
  };

  // display nothing if pagination is not loaded
  if (!pagination.length) {
    return "";
  }

  // function invoked when scrolled to a certain point
  const fetchCountries = () => {
    // if Infinite Scroll data caught up with fetched data
    // stop pushing data into it.
    if (pagination.length >= countries.length - 1) {
      setHasMore(false);
      return;
    }

    // if data in Infinite Scroll is less than the actual fetched data
    // push in 10 more data into infinite scroll when function is invoked
    if (pagination.length <= countries.length - 11) {
      for (let i = pagination.length; i < pagination.length + 10; i++) {
        setPagination((prevPag) => [...prevPag, countries[i]]);
      }
    } else {
      //else assuming there are less than 10 countries to fetch, push the last batch
      for (let i = pagination.length; i < countries.length; i++) {
        setPagination((prevPag) => [...prevPag, countries[i]]);
      }
    }
  };

  // Map all pagination data into cards
  let CountryCards = pagination.map((country, i) => {
    let coatOfArms;
    if (country.coatOfArms.png) {
      coatOfArms = country.coatOfArms.png;
    } else {
      coatOfArms = "";
    }
    return (
      <CountryCard
        size="4"
        key={`countryCard${i}`}
        flags={country.flags.png}
        coatOfArms={coatOfArms}
        name={country.name.common}
        region={country.subregion}
        capital={country.capital}
        population={country.population}
      />
    );
  });

  // Placeholders displayed while actual data load
  let TemplateCards = [];
  for (let i = 0; i < 15; i++) {
    TemplateCards.push(<PlaceholderCard key={`templateCard${i}`} />);
  }

  // Filter by country name input
  const handleFilter = (e) => {
    let words = e.target.value;

    setFilter(words);

    // If word is not presents, push data into infinite scroll
    if (words === "") {
      setPagination([]);
      for (let i = 1; i <= 15; i++) {
        setPagination((prevPag) => [...prevPag, countries[i]]);
      }
    } 
    else if (words <= 1) 
    {
      return;
    } 
    else //if there are words, filter the input and display
    {
      let filtering = countries.filter((country) => {
        return country.name.common.toLowerCase().includes(filter.toLowerCase());
      });

      if (filtering.length) {
        setPagination(filtering);
      }

      if (filtering.length === 0) {
        return <Heading>No results found</Heading>;
      }
    }
  };

  return (
    <div className="has-background-white-bis">
      <Header
        random={random}
        randomClick={handleRandomClick}
        key="randomcountry"
      />

        {/* Filter Input */}
      <Container>
        <Level pt={6}>
          <Level.Item renderAs={Columns.Column} align="left">
            <Control>
              <Input
                color="link"
                onChange={handleFilter}
                value={filter}
                placeholder="Filter By Country Name"
                type="text"
              />
              <BIcon align="left">
                <Icon size={1} path={mdiFilter} />
              </BIcon>
            </Control>
          </Level.Item>
          <Level.Item renderAs={Columns.Column} align="right">
            <Heading textSize={5} textWeight="bold">
              {countries.length}{" "}
              <span className="subtitle is-size-6 has-text-weight-normal">
                countries found
              </span>
            </Heading>
          </Level.Item>
        </Level>
        {/* { 
            countries[0] ? CountryCards : TemplateCards
        } */}

        {/* Check filter input, if active display results
            If not present, display infinite scroll of all countries
        */}
        {filter.length >= 1 ? (
          <Columns px={5}>{CountryCards}</Columns>
        ) : (
          <Columns>
          {/* Infinite scroll component */}
            <InfiniteScroll
              className="columns px-5 is-multiline"
              dataLength={pagination.length}
              next={fetchCountries}
              hasMore={hasMore}
              loader={<Columns multiline="false">{TemplateCards}</Columns>}
              endMessage={<Columns.Column mx="auto" size={12}>
                <hr/>
                <Heading textAlign="center" size={4}>End of result</Heading>
              </Columns.Column>}
            >
              {CountryCards}
            </InfiniteScroll>
          </Columns>
        )}
      </Container>
    </div>
  );
};

export default Home;
